/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import { useContext, useState } from 'react'
import useDeepCompareEffect from 'use-deep-compare-effect' //ref https://github.com/kentcdodds/use-deep-compare-effect
import { useCookies } from 'react-cookie'
import { AuthContext } from '../../auth/Auth'
const fetch = require('@vercel/fetch-retry')(require('node-fetch'))
// it is similar to useEffect... it helps to render the component and fetch the data than reflect on the component
// xhit is used for user refresh the data
// it took us into useDeepEffect which return us fe

export const useFetch = <queryType extends {}, responseType extends {}>(
  path: string,
  query: queryType,
  should_cancel: boolean,
  abort_check: () => boolean,
  xHit: number
) => {
  xHit = xHit ?? 0
  should_cancel = should_cancel === undefined ? true : should_cancel
  const [state, setState] = useState({
    status: 'none',
    loading: false,
    response: null as responseType | null,
    error: '',
    xHit: xHit,
  })
  const [cookies /* , setCookie, removeCookie */] = useCookies(['user_type', 'token'])

  const authContext = useContext(AuthContext)

  useDeepCompareEffect(() => {
    const abortCtrl = new AbortController()
    const opts = { signal: abortCtrl.signal, opts: { retries: 1 } }
    // console.log(opts);
    let mounted = true

    const shouldAbort = abort_check()
    //alert(shouldAbort)
    if (shouldAbort) {
      //alert(shouldAbort);
      setState((prev) => ({ ...prev, status: 'none', loading: false }))
      return () => {} //th to be updated
    }

    setState((prev) => {
      return {
        ...prev,
        status: 'pending',
        loading: true,
      }
    })
    //console.log("running");
    authContext
      .http(path, query)
      .then(({ json }: any) => {
        const data = json
        if (mounted) {
          // doubt
          if (
            (data.code === 500 && data?.internalCode === 'E_INVALID_API_TOKEN') ||
            data?.internalCode === 'E_UNAUTHORIZED_ACCESS'
          ) {
            authContext.checkAuth()
          } else {
            setState({
              ...state,
              status: 'success',
              response: data,
              loading: false,
              xHit,
            })
          }
        }
      })
      .catch((error: any) => {
        console.log(error.message)

        mounted && setState({ ...state, status: 'failed', error: error.message as string, loading: false, xHit })
      })

    return () => {
      mounted = false
      should_cancel && abortCtrl.abort()
    }
  }, [path, query, xHit])

  // console.log(state);
  return state
}
//  del- pending
//  delh - prev abort cancel
//

// ref = https://itnext.io/how-to-create-react-custom-hooks-for-data-fetching-with-useeffect-74c5dc47000a
